import resetState from './default';

const setID = (state, value) => state.id = value;
const setGUID = (state, value) => state.guid = value;
const setExistingCustomer = (state, value) => state.existingCustomer = value;
const pushContract = (state, value) => state.contracts.push(value);
const setLanguage = (state, value) => state.language = value;
const setCivility = (state, value) => state.civility = value;
const setLastName = (state, value) => state.lastName = value;
const setFirstName = (state, value) => state.firstName = value;
const setBirthDate = (state, value) => state.birthDate = value;
const setMail = (state, value) => state.mail = value;
const setMailRequired = (state, value) => state.mailRequired = value;
const setPhone = (state, value) => state.phone = value;
const setPhonePrefix = (state, value) => state.phone.prefix = value;
const setPhoneNumber = (state, value) => state.phone.number = value;
const setPhoneType = (state, value) => state.phone.type = value;
const setAddress = (state, value) => state.address = value;
const setAddressExist = (state, value) => state.address.exist = value;
const setAddressCountry = (state, value) => state.address.country = value;
const setAddressStreet = (state, value) => state.address.street = value;
const setAddressNumber = (state, value) => state.address.number = value;
const setAddressBox = (state, value) => state.address.box = value;
const setAddressLocality = (state, value) => state.address.locality = value;
const setAddressContact = (state, value) => state.addressContact = value;
const setAddressContactExist = (state, value) => state.addressContact.exist = value;
const setAddressContactCountry = (state, value) => state.addressContact.country = value;
const setAddressContactStreet = (state, value) => state.addressContact.street = value;
const setAddressContactNumber = (state, value) => state.addressContact.number = value;
const setAddressContactBox = (state, value) => state.addressContact.box = value;
const setAddressContactLocality = (state, value) => state.addressContact.locality = value;
const setSponsorCustomerId = (state, value) => state.sponsorCustomerId = value;
const setShowSponsor = (state, value) => state.showSponsor = value;
const setHasSponsorAlreadyBeenShown = (state, value) => state.hasSponsorAlreadyBeenShown = value;
const setCustomerType = (state, value) => state.customerType = value;
const setVatNumber = (state, value) => state.vatNumber = value;
const setCompanyName = (state, value) => state.companyName = value;
const setLegalForm = (state, value) => state.legalForm = value;
const setPaymentFrequency = (state, value) => state.paymentFrequency = value;
const setPaymentMode = (state, value) => state.paymentMode = value;
const setPartialDom = (state, value) => state.partialDom = value;
const setIban = (state, value) => state.iban = value;
const setHolderCivility = (state, value) => state.holderCivility = value;
const setHolderFirstName = (state, value) => state.holderFirstName = value;
const setHolderLastName = (state, value) => state.holderLastName = value;
const setCoholderCivility = (state, value) => state.coholderCivility = value;
const setCoholderFirstName = (state, value) => state.coholderFirstName = value;
const setCoholderLastName = (state, value) => state.coholderLastName = value;
const setAgreeDirectDebit = (state, value) => state.agreeDirectDebit = value;
const setReceiveInstalement = (state, value) => state.receiveInstalement = value;
const setInstalmentDay = (state, value) => state.instalmentDay = value;
const setBic = (state, value) => state.bic = value;
const setConditions = (state, value) => state.conditions = value;
const setOptinSales = (state, value) => state.optinSales = value;
const setOptin = (state, value) => state.optin = value;
const setOptinTA = (state, value) => state.optinTA = value;  //ER-710
const setInvoiceRemark = (state, value) => state.invoiceRemark = value;
const setInvoiceDeliveryMode = (state, value) => state.invoiceDeliveryMode = value;
const setSplitInstalments = (state, value) => state.splitInstalments = value;
const setHowDoYouKnow = (state, value) => state.howDoYouKnow = value;
const setProviderRequired = (state, value) => state.providerRequired = value;
const setAgentCustomId = (state, value) => state.agentCustomId = value;
const setAgentRefCustomId = (state, value) => state.agentCustomRefId = value;
const setAgentAllowBxlResi = (state, value) => state.agentAllowBxlResi = value;
const setAgentCheckEan = (state, value) => state.agentCheckEan = value;
const setStatusScenario = (state, value) => state.statusScenario = value;
const setSignatureDate = (state, value) => state.signatureDate = value;
const setSubscriptionDate = (state, value) => state.subscriptionDate = value;
const setIsValid = (state, value) => state.isValid = value;
const setProposalDate = (state, value) => state.proposalDate = value;
const setPromo = (state, value) => state.promo = value;
const setCampaign = (state, value) => state.campaign = value;
const setOrigin = (state, value) => state.origin = value;
const setSelfService = (state, value) => state.selfService = value;
const setShowTempContract = (state, value) => state.showTempContract = value;
const setSendRemark = (state, value) => state.sendRemark = value;
const reset = (state) => Object.assign(state, resetState.getDefaultState());

export default {
  setID,
  setGUID,
  setExistingCustomer,
  pushContract,
  setLanguage,
  setCivility,
  setLastName,
  setFirstName,
  setBirthDate,
  setMail,
  setMailRequired,
  setPhone,
  setPhonePrefix,
  setPhoneNumber,
  setPhoneType,
  setAddress,
  setAddressExist,
  setAddressCountry,
  setAddressStreet,
  setAddressNumber,
  setAddressBox,
  setAddressLocality,
  setAddressContact,
  setAddressContactExist,
  setAddressContactCountry,
  setAddressContactStreet,
  setAddressContactNumber,
  setAddressContactBox,
  setAddressContactLocality,
  setSponsorCustomerId,
  setShowSponsor,
  setHasSponsorAlreadyBeenShown,
  setCustomerType,
  setVatNumber,
  setCompanyName,
  setLegalForm,
  setPaymentFrequency,
  setPaymentMode,
  setPartialDom,
  setIban,
  setHolderCivility,
  setHolderFirstName,
  setHolderLastName,
  setCoholderCivility,
  setCoholderFirstName,
  setCoholderLastName,
  setAgreeDirectDebit,
  setReceiveInstalement,
  setInstalmentDay,
  setBic,
  setConditions,
  setOptinSales,
  setOptin,
  setOptinTA, //ER-710
  setInvoiceRemark,
  setInvoiceDeliveryMode,
  setSplitInstalments,
  setHowDoYouKnow,
  setProviderRequired,
  setAgentCustomId,
  setAgentAllowBxlResi,
  setAgentRefCustomId,
  setAgentCheckEan,
  setStatusScenario,
  setSignatureDate,
  setSubscriptionDate,
  setIsValid,
  setProposalDate,
  setPromo,
  setCampaign,
  setOrigin,
  setSelfService,
  setShowTempContract,
  setSendRemark,
  reset
};



// WEBPACK FOOTER //
// ./src/store/modules/subscription/mutations.js